export default __webpack_public_path__ + "static/media/09.3fd2969d.png";